import {remCalc} from '../../_utils'

export default {
    parts: ['promoTile', 'promoBanner'],

    baseStyle: {
        promoTile: {
            container: {
                width: '100%',
                height: 'auto',
                maxHeight: remCalc(79),
                alignItems: 'center',
                gap: {
                    base: 'xxsmall-1.base',
                    md: 'xxsmall-1.md',
                    lg: 'xxsmall-1.lg',
                    xl: 'xxsmall-1.xl',
                },
            },
            imageContainer: {
                width: remCalc(62),
                minWidth: remCalc(62),
                height: remCalc(62),
                alignItems: 'flex-start',
                justifyContent: 'center',
                borderRadius: 'medium-1',
                overflow: 'hidden',
            },
            subContainer: {
                width: '100%',
                justifyContent: 'flex-start',
                gap: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
            },
            infoContainer: {
                flexDir: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                gap: 'xsmall.base',
                width: '100%',
            },
            productName: {
                textStyle: 'body-small',
                fontWeight: 'medium',
                color: 'foreground.neutral.default',
                maxWidth: {
                    base: remCalc(120),
                    sm: remCalc(120),
                    md: remCalc(200),
                    lg: remCalc(200),
                },
            },
            productDescription: {
                textStyle: 'body-small',
                fontWeight: 'normal',
                color: 'foreground.neutral.muted',
            },
        },
        promoBanner: {
            outerContainer: {
                flexDir: 'row',
                alignItems: {base: 'flex-start', lg: 'center'},
                justifyContent: 'flex-start',
                gap: {
                    base: 'xsmall-1.base',
                    md: 'xsmall-1.md',
                    lg: 'xsmall-1.lg',
                    xl: 'xsmall-1.xl',
                },
                width: '100%',
                paddingY: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
            },
            image: {
                width: {base: remCalc(100), lg: remCalc(200)},
                height: {base: remCalc(100), lg: remCalc(200)},
                flexShrink: '0',
                imageFit: 'cover',
                borderRadius: 'large-1',
            },
            messageContainer: {
                gap: 'small.base',
                flexDir: 'column',
                height: 'stretch',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
            },
            promoLabel: {
                container: {
                    flexDir: 'row',
                    height: remCalc(22),
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: remCalc(4),
                    bg: 'background.base.elevated',
                    paddingY: {
                        base: 'xxxsmall.base',
                        md: 'xxxsmall.md',
                        lg: 'xxxsmall.lg',
                        xl: 'xxxsmall.xl',
                    },
                    paddingX: {
                        base: 'xxsmall.base',
                        md: 'xxsmall.md',
                        lg: 'xxsmall.lg',
                        xl: 'xxsmall.xl',
                    },
                    borderRadius: 'medium-1',
                    boxShadow:
                        'inset 0 0 0 1px var(--border-neutral-highlight, #FFF), 0 1px 2px 0 var(--shadow-neutral-xs, rgba(19, 24, 58, 0.08))',
                },
                icon: {
                    width: remCalc(12),
                    height: remCalc(12),
                    color: 'foreground.neutral.default',
                },
                text: {
                    flex: '1 0 0',
                    textStyle: 'body-xxsmall',
                    fontWeight: 'bold',
                    color: 'foreground.neutral.default',
                },
            },
            bannerTextContainer: {
                flexDir: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                gap: remCalc(6),
            },
            bannerTitle: {
                textStyle: 'body-xxlarge',
                fontWeight: 'medium',
                fontFamily: 'heading',
                color: 'foreground.neutral.default',
            },
            bannerText: {
                textStyle: 'body-small',
                fontWeight: 'normal',
                color: 'foreground.neutral.subtle',
            },
            bannerButton: {
                textStyle: 'body-small',
                fontWeight: 'medium',
                justifyContent: 'flex-start',
            },
            buttonIcon: {
                width: remCalc(10),
                height: remCalc(10),
                color: 'foreground.neutral.default',
            },
        },
    },
}
